import { BRANCH_HOLD_MESSAGE, activeBranchLabel } from "@/lib/branch-selection"
import { useAuth } from "@/lib/auth-context"

export function BranchWorkflowNotice({ pathname }: { pathname: string }) {
  const branch = activeBranchLabel()
  if (!branch?.secondary) return null
  if (pathname.startsWith("/dashboard/branches")) return null
  const restaurantFloor =
    pathname.startsWith("/dashboard/pos/tables")
    || pathname.startsWith("/dashboard/pos/kds")
    || pathname.startsWith("/dashboard/pos/orders")
    || pathname.startsWith("/dashboard/pos/history")
    || pathname.startsWith("/dashboard/restaurant")
    || pathname.startsWith("/dashboard/settings/kitchen-stations")
  const message = pathname.startsWith("/dashboard/settings/workers") || pathname.startsWith("/dashboard/admin")
    ? `${branch.name} is selected. Staff and workers on this branch only. Home branch is set when they are created.`
    : restaurantFloor
    ? `${branch.name} is selected. Tables, kitchen, and orders on this branch only.`
    : pathname.startsWith("/dashboard/settings")
    ? `${branch.name} is selected. Settings on this screen still apply to the whole tenant.`
    : pathname.startsWith("/dashboard/sales/clients") || pathname.startsWith("/dashboard/purchasing/suppliers")
      ? `${branch.name} is selected. Clients and suppliers on this branch only. Original branch is set when they are created.`
      : pathname.startsWith("/dashboard/stock") && !pathname.startsWith("/dashboard/stock/adjustment")
        ? `${branch.name} is selected. This catalog is this branch’s products plus anything marked shared with every branch.`
        : pathname.startsWith("/dashboard/sales") || pathname.startsWith("/dashboard/purchasing") || pathname.startsWith("/dashboard/stock")
          ? `${branch.name} is selected. Documents and stock on this branch only.`
          : pathname.startsWith("/dashboard/pos")
            ? `${branch.name} is selected. This till and its held carts belong to this branch.`
          : pathname.startsWith("/dashboard/reports") || pathname.startsWith("/dashboard/executive-reports") || pathname === "/dashboard"
            ? `${branch.name} is selected. Dashboard and reports on this branch only.`
          : `${branch.name} is selected. ${BRANCH_HOLD_MESSAGE}`
  return <p className="border-b bg-background px-4 py-2 text-sm" role="status">{message}</p>
}

export function OriginalBranchField({ name }: { name?: string | null }) {
  const { user } = useAuth()
  if (user?.features?.multiBranch !== true) return null
  const label = name?.trim() || activeBranchLabel()?.name || "Main Branch"
  return (
    <div>
      <label className="text-xs font-medium text-foreground">Original branch</label>
      <p className="mt-1 text-xs text-muted-foreground">{label}</p>
    </div>
  )
}

export function HomeBranchField({ name }: { name?: string | null }) {
  const { user } = useAuth()
  if (user?.features?.multiBranch !== true) return null
  const label = name?.trim() || activeBranchLabel()?.name || "Main Branch"
  return (
    <div>
      <label className="text-xs font-medium text-foreground">Home branch</label>
      <p className="mt-1 text-xs text-muted-foreground">{label}</p>
    </div>
  )
}

export function CatalogBranchFields({
  originalName,
  shared,
  onSharedChange,
}: {
  originalName?: string | null
  shared: boolean
  onSharedChange: (shared: boolean) => void
}) {
  const { user } = useAuth()
  if (user?.features?.multiBranch !== true) return null
  return (
    <div className="space-y-2 rounded-md border p-2">
      <OriginalBranchField name={originalName} />
      <label className="flex items-center gap-2 text-xs">
        <input type="checkbox" checked={shared} onChange={(event) => onSharedChange(event.target.checked)} />
        Shared with every branch
      </label>
    </div>
  )
}
